import { Skeleton, Typography } from "@mui/material"
import { groupBy, sortByLocation } from "@shared/lib/utils";
import MuiInput from "@shared/ui/mui-input/MuiInput";
import { StyledAddCar } from "./AddWork.styled";
import { UseFormReturn } from "react-hook-form";
import { WorkAdd } from "@models/work";
import { useTheme } from "@emotion/react";
import { useGetAccountStructureQuery } from "@features/structures/api/accountsStructure.api";

interface AddWorkProps {
  useForm: UseFormReturn<WorkAdd>
}

function AddWork({ useForm }: AddWorkProps) {

  const theme = useTheme();

  const { data: workStructure, isFetching } = useGetAccountStructureQuery("עבודה");

  
  const structureSortedByTitle = groupBy(sortByLocation(workStructure), "account_title")
  const customFieldsExist = structureSortedByTitle?.["מותאם אישית"]?.find(structure=> !!structure.show_form === true);


  return (
    <StyledAddCar>
      {isFetching && (<Skeleton variant="rectangular" height={500} animation="wave" sx={{ bgcolor: theme.colors.section_color }} />)}
      {!isFetching && workStructure &&
        <>
          <div>
            <Typography variant="body1">פרטי עבודה</Typography>
            <div className="fields">
              {structureSortedByTitle?.["פרטים"]?.map(field => {
                return field.show_form ? <MuiInput key={field.field_name} field={field} variant='outlined' useForm={useForm} showRequired/> : null
              })}
            </div>
          </div>

          <div>
            <Typography variant="body1">יצרן ודגם</Typography>
            <div className="fields">
              { structureSortedByTitle?.["יצרן ודגם"]?.map(field => {
                return field.show_form ? <MuiInput key={field.field_name} field={field} variant='outlined' useForm={useForm} showRequired/> : null
              })}
            </div>
          </div>

          <div>
            <Typography variant="body1">הכנסות והוצאות</Typography>
            <div className="fields">
              { structureSortedByTitle?.["הכנסות והוצאות"]?.map(field => {
                return field.show_form ? <MuiInput key={field.field_name} field={field} variant='outlined' useForm={useForm} showRequired/> : null
              })}
            </div>
          </div>

          <div>
            {customFieldsExist && (<Typography variant="body1">שדות מותאמים אישית:</Typography>)}
            <div className="fields">
              { structureSortedByTitle?.["מותאם אישית"]?.map(field => {
                return field.show_form ? <MuiInput key={field.field_name} field={field} variant='outlined' useForm={useForm} /> : null
              })}
            </div>
          </div>

        </>}

    </StyledAddCar>
  )
}

export default AddWork